import React from 'react'
import { Drawer } from 'antd'
import {
  CloseOutlined,
  UserOutlined,
  CalendarOutlined,
  HeartOutlined,
  ClockCircleOutlined,
  MedicineBoxOutlined,
} from '@ant-design/icons'
import moment from 'moment'
import '../css/admin.lite.scss'
import { capitalize } from 'lodash'
import { constants } from '../../constants'
import { useHistory, Redirect,useLocation } from 'react-router-dom'
const PatientInfo = (props) => {
  var history = useHistory()
  const location = useLocation();

    const handleNavigate = async (path, pathName) => {
      await history.push({ pathname: pathName, search: constants.ADMIN_LITE,state:{pathName:location.pathname} })
        if(!window.ReactNativeWebView)return;
      await window.ReactNativeWebView.postMessage(
        JSON.stringify({
          route: '/navigate',
          data: { path },
        })
      )
    }
  const showGraph=()=>{
      const pathName = `/activity/${props.patient?._id}`;
  const path = '/activity';
  handleNavigate(path, pathName);
  }
  return (
    <div>
      <Drawer
        getContainer={false}
        style={{ position: 'absolute' }}
        placement='right'
        onClose={() => props.handleDrawer(false)}
        open={props.open}
        width={300}
        closable={false}
      >
        <div className='drawer-header'>
          <h3>Patient Information</h3>
          <CloseOutlined
            onClick={() => props.handleDrawer(false)}
            className='close-icon'
          />
        </div>

        <div className='info-section'>
          <div className='info-row'>
            <UserOutlined className='info-icon' />
            <div>
              <div className='info-label'>Name</div>
              <div className='info-value'>
                {' '}
                {capitalize(props.patient?.firstname) +
                  ' ' +
                  capitalize(props.patient?.lastname)}
              </div>
            </div>
          </div>

          <div className='info-row'>
            <CalendarOutlined className='info-icon' />
            <div>
              <div className='info-label'>Date of Birth</div>
              <div className='info-value'>
                {moment(props.patient.dob).format(
                  constants.DATE_FORMAT.FORMAT1
                )}
              </div>
            </div>
          </div>

          <div className='info-row'>
            <MedicineBoxOutlined className='info-icon' />
            <div>
              <div className='info-label'>Surgery Type</div>
              <div className='info-value'>
                {props.patient.surgery?.type
                  ? capitalize(props.patient.surgery.type)
                  : 'NA'}
              </div>
            </div>
          </div>
          <div className='info-row'>
            <HeartOutlined className='info-icon' />
            <div>
              <div className='info-label'>Surgery Date</div>
              <div className='info-value'>
                {moment(props.patient.surgery?.date).format(
                  constants.DATE_FORMAT.FORMAT1
                )}
              </div>
            </div>
          </div>

          <div className='info-row'>
            <ClockCircleOutlined className='info-icon' />
            <div>
              <div className='info-label'>Last Activity</div>
              <div className='info-value'>
                {props.patient.lastLoggedinTime
                  ? moment(props.patient.lastLoggedinTime).format(
                      constants.DATE_FORMAT.FORMAT2
                    )
                  : 'NA'}
              </div>
            </div>
          </div>

          <div className='info-row'>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#999' }}>
              <svg 
               width="23"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                >
            <path d='M10.5,0 C7,0 3.9,1.9 2.3,4.8 L0,2.5 L0,9 L6.5,9 L3.7,6.2 C5,3.7 7.5,2 10.5,2 C14.6,2 18,5.4 18,9.5 C18,13.6 14.6,17 10.5,17 C7.2,17 4.5,14.9 3.4,12 L1.3,12 C2.4,16 6.1,19 10.5,19 C15.8,19 20,14.7 20,9.5 C20,4.3 15.7,0 10.5,0 L10.5,0 Z M9,5 L9,10.1 L13.7,12.9 L14.5,11.6 L10.5,9.2 L10.5,5 L9,5 L9,5 Z' />
          </svg>
               <div className='patient-progress' onClick={showGraph}>Patient Progress</div>
            </div>
          </div>
                     

        </div>
      </Drawer>
    </div>
  )
}

export default PatientInfo
